import { dataScore } from './dataScore';
import { nullableDataSpecificJsonData } from './dataSpecificJsonData';
import { dataPersonVORaw } from './dataPersonVORaw';
import { dataModuleType } from './dataModuleType';
import { moduleId, moduleName } from '@edgvr-front/modules/domain';

export const dataModuleVORaw = {
  type: 'object',
  required: [
    'Id',
    'ModuleName',
    'ModuleType',
    'MaxScore',
    'People',
    'SpecificJSONData',
  ],
  properties: {
    Id: moduleId,
    ModuleName: moduleName,
    ModuleType: dataModuleType,
    MaxScore: dataScore,
    People: {
      type: 'array',
      items: dataPersonVORaw,
    },
    SpecificJSONData: nullableDataSpecificJsonData,
  },
};
